function normalizeAppKey(rawKey) {
    if (!rawKey) return '';
    return String(rawKey).trim().replace(/^['"]|['"]$/g, '');
}

function resolveCreateUrl() {
    const freeQueryUrl =
        process.env.REACT_APP_YESAPI_FREEQUERY_URL ||
        process.env.NEXT_PUBLIC_YESAPI_FREEQUERY_URL;
    if (freeQueryUrl) {
        return freeQueryUrl.replace(/\/FreeQuery\/?$/i, '/Create');
    }

    const baseUrl =
        process.env.REACT_APP_YESAPI_BASE_URL ||
        process.env.NEXT_PUBLIC_YESAPI_BASE_URL ||
        // 兜底地址也要指向新网关：.env 万一没注入进来（构建环境漏配变量），
        // 旧默认值会让表单静默写回 YesApi，而管理端已经不在那边看了
        'https://api.dddi.com.au';

    return `${baseUrl.replace(/\/$/, '')}/App/Table/Create`;
}

const API_CONFIG = {
    APP_KEY: normalizeAppKey(
        process.env.REACT_APP_YESAPI_APP_KEY ||
            process.env.NEXT_PUBLIC_YESAPI_APP_KEY ||
            'A2E66F3417459D9EFA305A7E98E434AF'
    ),
    CREATE_URL: resolveCreateUrl(),
};

/**
 * 写入 contact_form_message 表（与 ignition_research 一致：YesAPI form-urlencoded）
 */
export async function createContactFormMessage(data) {
    if (!API_CONFIG.APP_KEY) {
        return { ok: false, message: '未配置 REACT_APP_YESAPI_APP_KEY' };
    }

    try {
        const response = await fetch(API_CONFIG.CREATE_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                app_key: API_CONFIG.APP_KEY,
                model_name: 'contact_form_message',
                data: JSON.stringify(data),
            }),
        });

        const result = await response.json().catch(() => ({}));
        const errCode = result?.data?.err_code;
        const errMsg = result?.data?.err_msg || result?.msg || '提交失败';

        if (!response.ok) {
            return { ok: false, message: errMsg };
        }

        if (typeof errCode !== 'undefined' && errCode !== 0) {
            return { ok: false, message: errMsg };
        }

        return { ok: true, data: result };
    } catch (error) {
        return {
            ok: false,
            message: error instanceof Error ? error.message : '网络错误',
        };
    }
}
